const CJS = require('crypto-js');

module.exports = class CryptoJS {
  constructor(key = 'defaul-key-of-gurhan') {
    this.key = key || process.env.key
  }
  crypto(originalText) {
    // Encrypt
    const ciphertext = CJS.AES.encrypt(originalText, this.key).toString();
    return ciphertext; // 'my message'
  }
  decrypto(ciphertext) {
    const bytes = CJS.AES.decrypt(ciphertext, this.key);
    const originalText = bytes.toString(CJS.enc.Utf8);
    return originalText;
  }
}